export enum FileUploadType {
  file = 'File',
  folderFile = 'FolderFile',
  zipCctv = 'ZipCctv',
  zipGeneralContent = 'ZipGeneralContent',
  zipDeviceBackup = 'ZipDeviceBackup',
  cctvFile = 'CctvFile',
  deviceBackupFile = 'DeviceBackupFile',
  generalContentFile = 'GeneralContentFile'
}